import { render } from "./Servicos.vue?vue&type=template&id=1fabc810&scoped=true"
import script from "./Servicos.vue?vue&type=script&lang=js"
export * from "./Servicos.vue?vue&type=script&lang=js"

import "./Servicos.vue?vue&type=style&index=0&id=1fabc810&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fabc810"]])

export default __exports__